import { apiRequest } from '../../api-client';
import type { ExportSlug } from './subscription-member-report';

export interface AuthReportRow {
  username: string;
  firstName: string;
  lastName: string;
  createDate: string;
  lastAxeProLogin: string;
  lastHtmlDocsLogin: string;
  lastMonitorLogin: string;
  lastDequeULogin: string;
  lastMonitorReportsLogin: string;
  lastMobileLogin: string;
  lastDtReportsLogin: string;
  lastAuditorLogin: string;
  devHubAdded: string;
  linterAdded: string;
  rootGroup: string;
}

export interface AuthUserReportResult {
  rows: AuthReportRow[];
  csvContent: string;
  rowCount: number;
}

interface GetAuthUserReportParams {
  token: string;
  enterpriseId: string;
  product: ExportSlug;
}

/**
 * Generates a detailed auth/login report for an enterprise and product.
 *
 * GET /api-internal/auth-user-report?enterpriseId=<id>&product=<slug>
 */
export function getAuthUserReport({
  token,
  enterpriseId,
  product
}: GetAuthUserReportParams): Promise<AuthUserReportResult> {
  const params = new URLSearchParams({ enterpriseId, product });

  return apiRequest<AuthUserReportResult>({
    method: 'GET',
    endpoint: `/api-internal/auth-user-report?${params}`,
    token
  });
}
